export default __webpack_public_path__ + "static/barcade-brawl-e290a6ae4b655e8a5ac3ef98beae3152.ttf";